(() => {
  if (customElements.get('army-product-grid')) return;
  const storageKey = 'ac-home-product-columns';
  class ArmyProductGrid extends HTMLElement {
    connectedCallback() {
      let columns = window.matchMedia('(min-width: 768px)').matches ? '2' : '1';
      try {
        const saved = localStorage.getItem(storageKey);
        if (saved === '1' || saved === '2') columns = saved;
      } catch (_) { /* The selector also works when storage is unavailable. */ }
      this.setColumns(columns);
      this.querySelector('.ac-grid-choice').hidden = false;
      this.onclick = (event) => {
        const button = event.target.closest('button[data-columns]');
        if (!button || !this.contains(button)) return;
        const value = button.dataset.columns;
        document.querySelectorAll('army-product-grid').forEach((grid) => grid.setColumns(value));
        try { localStorage.setItem(storageKey, value); } catch (_) { /* Optional persistence. */ }
      };
    }
    setColumns(columns) {
      this.dataset.columns = columns;
      this.querySelectorAll('button[data-columns]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.columns === columns));
      });
    }
  }
  customElements.define('army-product-grid', ArmyProductGrid);
})();
